import React from "react";

import { bazaarUrl } from "@/mk2/apps/bazaar/urls";
import { forumUrl } from "@/mk2/apps/forum/urls";
import { blogsPopularFeedUrl } from "@/mk2/apps/blogs/urls";
import { groupsListUrl } from "@/mk2/apps/groups/urls";
import { WIKI_REVIEWS_ARTICLE_SLUG } from "@/mk2/apps/wiki/helpers";
import { getWikiArticleUrl } from "@/mk2/apps/wiki/urls";
import { Link } from "@/mk2/components/Link";
import {
    BAZAAR,
    BLOGS,
    HOMEPAGE_FEED_NAV_TAB_FORUM,
    MAIN_MENU_REVIEWS,
    TAB_GROUPS,
} from "@/mk/autogenerated/translation";

import styles from "./NavigationPills.mscss";

const PILLS = [
    { label: HOMEPAGE_FEED_NAV_TAB_FORUM, href: forumUrl },
    { label: BLOGS, href: blogsPopularFeedUrl },
    { label: TAB_GROUPS, href: groupsListUrl },
    { label: BAZAAR, href: bazaarUrl },
    {
        label: MAIN_MENU_REVIEWS,
        href: getWikiArticleUrl(WIKI_REVIEWS_ARTICLE_SLUG, WIKI_REVIEWS_ARTICLE_SLUG),
    },
];

export const NavigationPills: React.FC = () => (
    <nav className={styles.NavigationPills}>
        {PILLS.map((pill, i) => (
            <Link key={i} to={pill.href} className={styles.NavigationPills__pill}>
                {pill.label}
            </Link>
        ))}
    </nav>
);
